const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Eps24 = function Eps24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement(
      "mask",
      {
        id: "mask0_1_3",
        style: {
          maskType: "luminance",
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "33",
        height: "24",
      },
      /*#__PURE__*/ React.createElement("path", {
        d: "M33 0H0V24H33V0Z",
        fill: "white",
      })
    ),
    /*#__PURE__*/ React.createElement(
      "g",
      {
        mask: "url(#mask0_1_3)",
      },
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask1_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask1_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M24.3399 12.7196H21.9065C21.6358 12.7196 21.4157 12.504 21.4157 12.234C21.4157 11.9641 21.6359 11.7264 21.9065 11.7264H25.6112V9.89893H21.9065C20.6135 9.89893 19.5614 10.9531 19.5614 12.2429C19.5614 13.5327 20.6135 14.5869 21.9065 14.5869H24.3069C24.5776 14.5869 24.7978 14.8016 24.7978 15.0716C24.7978 15.3415 24.5775 15.5403 24.3069 15.5403H19.1596C18.7226 16.3746 18.2977 17.0897 17.4351 17.4473H24.3399C25.6112 17.429 26.6512 16.3531 26.6512 15.0747C26.6512 13.7963 25.6112 12.7379 24.3399 12.7196Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask2_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask2_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M15.0116 9.89893C12.9491 9.89893 11.2693 11.5888 11.2693 13.6652V13.7446V21.4996H13.1365V17.4473H15.0077C17.0702 17.4473 18.7441 15.735 18.7441 13.6586C18.744 11.5822 17.0741 9.89893 15.0116 9.89893ZM15.0116 15.5403H13.1365V13.6586C13.1365 12.607 13.9737 11.7515 15.0116 11.7515C16.0495 11.7515 16.8938 12.607 16.8938 13.6586C16.8938 14.7101 16.0495 15.5403 15.0116 15.5403Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask3_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask3_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M5.35788 17.4475C3.59236 17.4475 2.10803 16.1894 1.70638 14.5459C1.70638 14.5459 1.59034 14.0025 1.59034 13.6446C1.59034 13.2868 1.70018 12.7378 1.70018 12.7378C2.10474 11.0983 3.58724 9.87743 5.34986 9.87743C7.42292 9.87743 9.124 11.5626 9.124 13.6356V14.5473H3.61628C3.94153 15.183 4.59931 15.5405 5.35788 15.5405H10.3091L10.3158 10.1645C10.3158 9.36303 9.66013 8.70728 8.85861 8.70728H1.8411C1.03958 8.70728 0.383789 9.34317 0.383789 10.1447V17.1622C0.383789 17.9637 1.03958 18.6393 1.8411 18.6393H8.85861C9.57789 18.6393 10.1779 18.1229 10.2938 17.4475H5.35788Z",
          fill: "#C8036F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask4_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask4_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M5.34969 11.6611C4.59406 11.6611 3.93692 12.1237 3.61035 12.7197H7.08911C6.76255 12.1237 6.10544 11.6611 5.34969 11.6611Z",
          fill: "#C8036F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask5_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask5_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M8.52788 6.42512C8.52788 4.7124 7.1045 3.32397 5.34871 3.32397C3.622 3.32397 2.21765 4.66699 2.17152 6.34046C2.17077 6.34753 2.17137 6.3544 2.17137 6.36167V7.29362C2.17137 7.4051 2.26215 7.5153 2.3764 7.5153H3.54604C3.6603 7.5153 3.7605 7.4051 3.7605 7.29362V6.42512C3.7605 5.56985 4.47282 4.87401 5.34962 4.87401C6.22643 4.87401 6.93875 5.56985 6.93875 6.42512V7.29362C6.93875 7.4051 7.03144 7.5153 7.1457 7.5153H8.31538C8.42964 7.5153 8.52788 7.4051 8.52788 7.29362V6.42512Z",
          fill: "#C8036F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask6_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask6_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M17.1063 19.8709L16.9372 20.8283C16.8527 21.3122 16.5356 21.5338 16.1058 21.5338C15.7418 21.5338 15.46 21.2965 15.5422 20.8291L15.7112 19.871H15.972L15.8028 20.8283C15.7511 21.1267 15.885 21.2966 16.1387 21.2966C16.3994 21.2966 16.6225 21.1416 16.6764 20.8291L16.8456 19.871L17.1063 19.8709ZM16.0823 19.5711C16.0823 19.651 16.1434 19.6885 16.2091 19.6885C16.2913 19.6885 16.3806 19.6298 16.3806 19.5195C16.3806 19.442 16.3288 19.4021 16.2608 19.4021C16.1763 19.4021 16.0823 19.4561 16.0823 19.5711ZM16.646 19.5688C16.646 19.651 16.7094 19.6885 16.7775 19.6885C16.8503 19.6885 16.9467 19.6298 16.9467 19.5218C16.9467 19.4444 16.8902 19.4021 16.8268 19.4021C16.7423 19.4021 16.646 19.4561 16.646 19.5688Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask7_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask7_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M17.7363 19.8708L17.6189 20.5324C17.7198 20.3962 17.9218 20.3243 18.0627 20.3243C18.354 20.3243 18.5559 20.4949 18.5559 20.8119C18.5559 21.2604 18.2436 21.5302 17.8444 21.5302C17.6894 21.5302 17.5578 21.4726 17.478 21.327L17.4334 21.4997H17.2056L17.4944 19.8708H17.7363ZM17.5532 20.9873C17.5438 21.1799 17.6682 21.3043 17.849 21.3043C18.0768 21.3043 18.2976 21.1281 18.3117 20.8605C18.3211 20.6655 18.1943 20.5504 18.0181 20.5504C17.7926 20.5504 17.5672 20.7313 17.5532 20.9873Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask8_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask8_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M19.031 21.0229C19.0216 21.1818 19.1461 21.3115 19.3575 21.3115C19.4749 21.3115 19.6298 21.2657 19.7144 21.1858L19.8459 21.3378C19.7027 21.4693 19.4913 21.5347 19.3129 21.5347C18.9794 21.5347 18.7844 21.335 18.7844 21.0296C18.7844 20.6233 19.1038 20.3206 19.5124 20.3206C19.8858 20.3206 20.0972 20.5461 19.9704 21.0229H19.031ZM19.7731 20.8242C19.7919 20.6256 19.6745 20.5447 19.4795 20.5447C19.3034 20.5447 19.1414 20.6256 19.0709 20.8242H19.7731Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask9_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask9_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M20.6165 20.3477L20.6047 20.5008C20.7176 20.3527 20.8538 20.3225 20.9782 20.3225C21.0909 20.3225 21.1918 20.3625 21.2459 20.4212L21.1003 20.6325C21.0486 20.5857 20.9969 20.5622 20.9077 20.5622C20.7409 20.5622 20.5766 20.6622 20.539 20.8759L20.4287 21.4998H20.1868L20.3911 20.3477H20.6165Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask10_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask10_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M22.4111 20.3477L22.5332 21.2588L22.9747 20.3477H23.2448L22.6389 21.4998H22.3547L22.2397 20.7397L22.0541 21.1173L21.8522 21.4998H21.5703L21.366 20.3477H21.6384L21.7582 21.2588L22.202 20.3477H22.4111Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask11_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask11_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M23.5557 21.0229C23.5463 21.1818 23.6707 21.3115 23.8821 21.3115C23.9996 21.3115 24.1545 21.2657 24.239 21.1858L24.3706 21.3378C24.2274 21.4693 24.016 21.5347 23.8375 21.5347C23.504 21.5347 23.3091 21.335 23.3091 21.0296C23.3091 20.6233 23.6285 20.3206 24.0371 20.3206C24.4105 20.3206 24.6219 20.5461 24.495 21.0229H23.5557ZM24.2978 20.8242C24.3165 20.6256 24.1992 20.5447 24.0042 20.5447C23.8281 20.5447 23.666 20.6256 23.5955 20.8242H24.2978Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask12_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask12_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M25.1577 20.3475L24.9534 21.4996H24.7114L24.9158 20.3475H25.1577ZM24.944 20.0337C24.944 20.1158 25.0051 20.1583 25.0708 20.1583C25.1647 20.1583 25.2516 20.0971 25.2516 19.9821C25.2516 19.9045 25.1929 19.8599 25.1295 19.8599C25.0426 19.8599 24.944 19.9163 24.944 20.0337Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask13_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask13_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M26.2311 20.6325C26.1559 20.548 26.0597 20.5245 25.9446 20.5245C25.7848 20.5245 25.6722 20.5785 25.6722 20.6795C25.6722 20.764 25.7637 20.7994 25.9 20.8111C26.1113 20.8298 26.3814 20.9003 26.325 21.1986C26.2851 21.4146 26.0691 21.5414 25.7684 21.5414C25.5806 21.5414 25.3997 21.4991 25.2776 21.3277L25.4349 21.1563C25.5218 21.276 25.6745 21.3254 25.8107 21.3277C25.9257 21.3277 26.062 21.2855 26.0831 21.1774C26.1042 21.0741 26.0126 21.0342 25.8436 21.0177C25.6463 20.9989 25.4303 20.9262 25.4303 20.7077C25.4303 20.4189 25.7425 20.3179 25.9774 20.3179C26.1559 20.3179 26.2874 20.3578 26.3955 20.4729L26.2311 20.6325Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask14_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask14_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M26.9946 20.3477L26.8843 20.9681C26.849 21.1654 26.9383 21.3017 27.1402 21.3017C27.3304 21.3017 27.4925 21.1441 27.5253 20.9516L27.631 20.3477H27.8729L27.6686 21.4998H27.4502L27.4666 21.3328C27.3304 21.462 27.1965 21.5229 27.0345 21.5229C26.7504 21.5229 26.5813 21.3192 26.6423 20.9694L26.7527 20.3477H26.9946Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask15_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "1",
          width: "36",
          height: "23",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.3184 1H-2V23.9232H33.3184V1Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask15_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M28.935 21.4997L29.0453 20.8831C29.0805 20.6834 29.0125 20.5512 28.7917 20.5512C28.5991 20.5512 28.437 20.7061 28.4042 20.8963L28.2985 21.4997H28.0566L28.261 20.3476H28.4817L28.4653 20.516C28.5992 20.3915 28.7377 20.3301 28.888 20.3301C29.1699 20.3301 29.3531 20.5262 29.2897 20.8808L29.1792 21.4997H28.935Z",
          fill: "#71706F",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "mask",
        {
          id: "mask16_1_3",
          style: {
            maskType: "luminance",
          },
          maskUnits: "userSpaceOnUse",
          x: "-2",
          y: "3",
          width: "36",
          height: "20",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M33.494 3.21826H-2V22.4442H33.494V3.21826Z",
          fill: "white",
        })
      ),
      /*#__PURE__*/ React.createElement(
        "g",
        {
          mask: "url(#mask16_1_3)",
        },
        /*#__PURE__*/ React.createElement("path", {
          d: "M29.7549 21.6585C29.7385 21.8174 29.8606 21.8816 30.065 21.8816C30.2435 21.8816 30.4361 21.782 30.4807 21.5284L30.5159 21.3305C30.4102 21.4785 30.2176 21.5369 30.0744 21.5369C29.7785 21.5369 29.5718 21.3606 29.5718 21.0412C29.5718 20.5856 29.91 20.3225 30.2928 20.3225C30.4549 20.3225 30.6005 20.3995 30.6522 20.531L30.6921 20.3474H30.9269L30.7249 21.5337C30.6498 21.973 30.3234 22.1092 30.0251 22.1092C29.6681 22.1092 29.4709 21.9365 29.5202 21.6584L29.7549 21.6585ZM29.823 20.9942C29.823 21.1914 29.9522 21.3112 30.1379 21.3112C30.638 21.3112 30.7719 20.5432 30.2716 20.5432C30.0344 20.5433 29.823 20.7193 29.823 20.9942Z",
          fill: "#71706F",
        })
      )
    )
  );
};
Eps24.defaultProps = {
  width: "33",
  height: "24",
  viewBox: "0 0 33 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Eps24,
};
export function Eps(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Eps' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
